export const mainMaterialList = [
    { value: '1', text: 'Basalt' },
    { value: '2', text: 'Beton' },
    { value: '3', text: 'Beton / Hout' },
    { value: '4', text: 'Beton / Metselwerk' },
    { value: '5', text: 'Beton / Staal' },
    { value: '6', text: 'Composiet' },
    { value: '7', text: 'Grond' },
    { value: '8', text: 'Hout' },
    { value: '9', text: 'Hout / Composiet' },
    { value: '10', text: 'Kunststof' },
    { value: '11', text: 'Metselwerk' },
    { value: '12', text: 'Metselwerk / Beton' },
    { value: '13', text: 'Natuursteen' },
    { value: '14', text: 'Ongedefinieerd' },
    { value: '15', text: 'Schanskorven' },
    { value: '16', text: 'Staal' },
    { value: '17', text: 'Staal / Beton' },
    { value: '18', text: 'Staal / Composiet' },
    { value: '19', text: 'Staal / Hout' },
    { value: '20', text: 'Staal / Kunststof' },
    { value: '21', text: 'Staal / Metselwerk' },
    { value: '22', text: 'Steen' },
    { value: '23', text: 'Stortsteen' },
];
